import queryString from 'query-string';
import env from 'utils/env';
import { getCampaignType, campaignId } from 'utils/campaign';
import cookie, { COOKIE_NAMES } from 'utils/cookie';
import request from './request';
import requestJson from './requestJson';

export const updatePassword = (passwords) => {
  return request(
    `${env.user}/self/password`,
    'PATCH',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(passwords)
  );
};

export const updateShippingInfo = (ShippingInfo) => {
  return request(
    `${env.user}/self/shipping`,
    'PATCH',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(ShippingInfo)
  );
};

export const getIsAccountPastDue = () =>
  request(`${env.aceApi}/1/accounts/past-due`);

export const updateProducts = (campaignId, productsToUpdate) => {
  const requestUrl = `${env.aceApi}/1/campaigns/${campaignId}/product-bundles`;
  const data = JSON.stringify(productsToUpdate);
  return request(
    requestUrl,
    'PUT',
    { 'Content-Type': 'application/json' },
    data
  );
};

export const updateProfileInfo = (profileInfo) => {
  const requestUrl = `${env.aceApi}/1/accounts/profiles`;
  const data = JSON.stringify(profileInfo);
  return request(
    requestUrl,
    'PUT',
    { 'Content-type': 'application/json' },
    data
  );
};

export function getAccount() {
  const requestUrl = `${env.aceApi}/1/accounts`;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v2+json',
  };
  return request(requestUrl, 'GET', headers);
}

export const getUserNextRenewal = () => {
  const requestUrl = `${env.aceApi}/1/accounts/next-renewal`;
  return request(requestUrl);
};

export const getInvoicesByUserId = (userId, limit, offset) => {
  const queryParams = {};
  if (limit) {
    queryParams.limit = limit;
    queryParams.offset = offset;
  }
  const requestUrl = `${env.aceApi}/1/invoices/users/${userId}`;
  const endpoint = limit
    ? `${requestUrl}?${queryString.stringify(queryParams, {
        arrayFormat: 'comma',
      })}`
    : requestUrl;
  const headers = {
    Accept: 'application/vnd.fabfitfun.v2+json',
  };
  return request(endpoint, 'GET', headers);
};

export const getUserCredits = () => request(`${env.aceApi}/1/credits/users`);

export const getSocialCredit = (teamId) =>
  request(`${env.aceApi}/1/credits/teams/${teamId}`);

export const getRemainingBoxes = () =>
  request(`${env.aceApi}/1/accounts/remaining-boxes`);

export function getCredit() {
  let requestUrl = `${env.aceApi}/1/credits?type=${getCampaignType()}`;
  if (campaignId !== null) {
    requestUrl += `&campaignId=${campaignId}`;
  }
  return request(requestUrl);
}

export const getUserAvatar = () => request(`${env.avatarApi}/self/avatar`);

export const setUserAvatar = (formData) => {
  return request(
    `${env.avatarApi}/self/avatar`,
    'PUT',
    {
      'FFF-Auth': 'V1.1',
    },
    formData
  );
};

export const clearUserCache = () => {
  const endpoint = `${env.aceApi}/1/caches/self/evict-user`;
  return request(endpoint, 'DELETE', {
    'Content-Type': 'application/json',
  });
};

export const getUserRoles = () => request(`${env.aceApi}/1/accounts/roles`);

export const createSessionId = () => {
  const headers = {
    accept: 'application/vnd.fabfitfun.v1+json',
    'Content-Type': 'application/json',
  };
  const body = JSON.stringify({
    countryIsoCode: 'US',
  });
  return requestJson(`${env.user}/public/create`, 'POST', headers, body);
};
